import {BaseFactory} from "../../../../infrastructure/factories/base-factory";
import {DateFormatApiModel} from "../models/date-format-api-model";
import {DateFormatDomainModel} from "../models/date-format-domain-model";

class DatetimeFactory extends BaseFactory {
  constructor() {
    super('datetimeFactory')
  }

  validateRequiredTypes() {}

  createDateFormatDomainObject(apiModel: DateFormatApiModel): DateFormatDomainModel {
    const shortTimePattern: String = apiModel.Use24Clock ? apiModel.ShortTimePattern24 : apiModel.ShortTimePattern12;
    const longTimePattern: String = apiModel.Use24Clock ? apiModel.LongTimePattern24 : apiModel.LongTimePattern12;
    const fullDateTimePattern: String = apiModel.Use24Clock ? apiModel.FullDateTimePattern24 : apiModel.FullDateTimePattern12;

    const domain: DateFormatDomainModel = new DateFormatDomainModel(apiModel, shortTimePattern, longTimePattern, fullDateTimePattern);

    return domain;
  }
}

export const datetimeFactory = new DatetimeFactory();
